import { createParseAsEnumListFilter } from '@app/core/list-view/helpers/create-parse-as-enum-list-filter';
import { StatusFilterType } from '../components/options';

/**
 * nuqs parser for the status screen `status` query param.
 * Supports a comma-separated list (e.g. `online,offline`) or a single value.
 * Null/absent means no activity filter (show online and offline).
 * Legacy `all` is treated as null.
 */
export const parseAsStatusActivityFilter = createParseAsEnumListFilter(
  Object.values(StatusFilterType),
  { treatAsNull: ['all'] },
);
